import { createContext, useContext, useState } from "react";

export const LogHistoryContext = createContext();
LogHistoryContext.displayName = "LogHistory";
export const useLogHistory = () => useContext(LogHistoryContext);

const LogHistoryProvider = ({ children }) => {
    const [showLogHistoriesInControl, setShowLogHistoriesInControl] = useState(false);

    return (
        <LogHistoryContext.Provider
            value={{
                showLogHistoriesInControl,
                setShowLogHistoriesInControl,
            }}
        >
            {children}
        </LogHistoryContext.Provider>
    );
};

export default LogHistoryProvider;
